import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMPERSONATION_TOKEN_KEY } from '@qtek/shared/utils';

@Injectable({ providedIn: 'root' })
export class ImpersonationInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token = sessionStorage.getItem(IMPERSONATION_TOKEN_KEY);
    if (!token) return next.handle(req);
    if (!req.url.includes('/api/v1/admin/login-as-another-user')) {
      return next.handle(req);
    }
    return next.handle(
      req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    );
  }
}
